import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./_app.extend";
import addFmSearch from "./_fmSearch";
import addFmCsv from "./_fmCsv";
import addFuncHeader from "./_funcHeader";
import addDataTable from "./_dataTable";

// [listSection] VuwFade
// 一覧用コンポーネント
!!vuwer.get("pageMain") && vuwer.add("listSection", {
	vuwType: "fade",
	selector() {
		return $("<div/>").addClass("section vuw-fade").attr({
			"id": "list_section",
			"data-section": "list",
			"data-visible": "0"
		}).appendTo( vuwer.get("pageMain").$self );
	},
	
	onReady($self) {
		this.$content = $("<div/>").addClass("content").appendTo($self);
	},
	
	async refresh() {
		const methods = [];
		this.getChildren().forEach(vuw => {
			u_.isFunction(vuw.refresh) && methods.push( vuw.refresh() );
		});
		return Promise.all(methods);
	}
}, function() {
	addFmSearch(this);
	addFmCsv(this);
	addFuncHeader(this);
	addDataTable(this, app.module);
});
